import axios from "axios";
import { formatMilliseconds } from "utils/Formatter";

// cria instância já com o prefixo
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

class DataService {
  // GRAMMAR
  createNonRecursiveInitial(dados, cred) {
    return api.post("/grammar/nonRecursiveInitial", dados, cred);
  }

  createNonContracting(dados, cred) {
    return api.post("/grammar/nonContracting", dados, cred);
  }

  createNonCascade(dados, cred) {
    return api.post("/grammar/nonCascade", dados, cred);
  }

  createOnlyTerm(dados, cred) {
    return api.post("/grammar/onlyTerm", dados, cred);
  }

  createOnlyReach(dados, cred) {
    return api.post("/grammar/onlyReach", dados, cred);
  }

  createGrId(dados, cred) {
    return api.post("/grammar/grammaId", dados, cred);
  }

  createRemovingTheImmediateLeftRecursion(dados, cred) {
    return api.post("/grammar/immedLeftRecursion", dados, cred);
  }

  createRemovalDirLeftRec(dados, cred) {
    return api.post("/grammar/removalDirLeftRec", dados, cred);
  }

  createChomsky(dados, cred) {
    return api.post("/grammar/chomSkyandgreibach", dados, cred);
  }

  createCYK(dados, cred) {
    return api.post("/grammar/cyk", dados, cred);
  }

  createLeftMostDerivation(dados, cred) {
    return api.post("/grammar/leftMostDerivation", dados, cred);
  }

  createCheckAmbiguity(dados, cred) {
    return api.post("/grammar/checkAmbiguity", dados, cred);
  }

  CfgToPda(dados, cred) {
    return api.post("/grammar/cfgToPda", dados, cred);
  }

  createHTML(dados, cred) {
    return api.post("/grammar/HTML", dados, cred);
  }

  getGramatica(cred) {
    return api.get("/grammar", cred);
  }

  getGramaticaHTML(cred) {
    return api.get("/grammar/html", cred);
  }

  checkGrammarWord(dados, word, cred) {
    return api.post(`/grammar/checkWord/${word}`, dados, cred);
  }

  // AUTOMATON
  createGraph(dados, cred) {
    return api.post("/automaton/HTML", dados, cred);
  }

  getAutomatonByDOT(dados, cred) {
    return api.post("/fsa/dotToAutomaton", dados, cred);
  }

  seeIfCompleteAutomaton(dados, cred) {
    return api.post("/fsa/seeIfComplete", dados, cred);
  }

  createCompleteAutomaton(dados, cred) {
    return api.post("/fsa/createComplete", dados, cred);
  }

  seeIfAFDAutomaton(dados, cred) {
    return api.post("/fsa/seeIfAFD", dados, cred);
  }

  seeIfAFNDLambdaAutomaton(dados, cred) {
    return api.post("/fsa/seeIfAFNDLambda", dados, cred);
  }

  convertAFNDtoAFD(dados, cred) {
    return api.post("/fsa/AFNDtoAFD", dados, cred);
  }

  convertAFNDLambdaToAFND(dados, cred) {
    return api.post("/fsa/AFNDLambdatoAFD", dados, cred);
  }

  testInputString(dados, cred) {
    return api.post("/fsa/testInputString", dados, cred);
  }

  getTransitionTableAFNDLambda(dados, cred) {
    return api.post("/fsa/tableAFNDLambda", dados, cred);
  }

  getTransitionTableAFND(dados, cred) {
    return api.post("/fsa/tableAFND", dados, cred);
  }

  getTransitionTableAFD(dados, cred) {
    return api.post("/fsa/tableAFD", dados, cred);
  }

  getMinimazeAutomaton(dados, cred) {
    return api.post("/fsa/afdMinization", dados, cred);
  }

  getTableMinimization(dados, cred) {
    return api.post("/fsa/afdTableMinization", dados, cred);
  }

  getAutomatonByRegex(dados, cred) {
    const form = new FormData();
    form.append("regex", dados);
    return api.post("/fsa/getAutomatonByRegex", form, cred);
  }

  checkWord(dados, word, cred) {
    return api.post(`/fsa/checkWord/${word}`, dados, cred);
  }

  getGridPositions(dados, cred) {
    return api.post("/fsa/gridPositions", dados, cred);
  }

  //PDA
  checkPDAWord(dados, word, criterion, cred) {
    return api.post(`/pda/checkWord/${word}/${criterion}`, dados, cred);
  }

  //LBA
  checkLBAWord(dados, word, cred) {
    return api.post(`/lba/checkWord/${word}`, dados, cred);
  }

  //TM
  checkTMWord(dados, word, cred) {
    return api.post(`/tm/checkWord/${word}`, dados, cred);
  }

  // USER
  signUp(user) {
    return api.post("/signUp", user);
  }

  login(dataLogin) {
    return api.post("/auth/signin", dataLogin);
  }

  logoutToken(cred) {
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: cred.headers.Authorization,
      },
    };

    return api.post("/token", cred.headers.Authorization.split("."), config);
  }

  logout() {
    return api.get("/logout");
  }

  getUserByEmail(email, cred) {
    return api.get(`/user/${email}`, cred);
  }

  postSaveHistoricalGr(email, historicalGrammar, cred) {
    return api.post(`/${email}/user/grammar`, historicalGrammar, cred);
  }

  postSaveHistoricalMc(email, historicalMachine, cred) {
    return api.post(`/${email}/user/machine`, historicalMachine, cred);
  }

  updateHistoricalMc(email, historicalMachine, createdDate, cred) {
    const formattedDate = formatMilliseconds(createdDate);
    return api.put(
      `/${email}/user/machine/${encodeURIComponent(formattedDate)}`,
      historicalMachine,
      cred
    );
  }

  updateHistoricalGr(email, historicalGrammar, createdDate, cred) {
    const formattedDate = formatMilliseconds(createdDate);
    return api.put(
      `/${email}/user/grammar/${encodeURIComponent(formattedDate)}`,
      historicalGrammar,
      cred
    );
  }

  deleteHistoricalMc(email, createdDate, cred) {
    const formattedDate = formatMilliseconds(createdDate);
    const dateEncoded = window.btoa(formattedDate);
    return api.delete(
      `/${email}/user/machine/deleteByCreatedDate/${dateEncoded}`,
      {
        headers: {
          Authorization: cred,
        },
      }
    );
  }

  deleteHistoricalGr(email, createdDate, cred) {
    const formattedDate = formatMilliseconds(createdDate);
    const dateEncoded = window.btoa(formattedDate);
    return api.delete(
      `/${email}/user/grammar/deleteByCreatedDate/${dateEncoded}`,
      {
        headers: {
          Authorization: cred,
        },
      }
    );
  }

  deleteMachineOlderThan(email, months, cred) {
    return api.delete(`/${email}/user/machine/deleteOlderThan/${months}`, {
      headers: {
        Authorization: cred,
      },
    });
  }

  deleteGrammarOlderThan(email, months, cred) {
    return api.delete(`/${email}/user/grammar/deleteOlderThan/${months}`, {
      headers: {
        Authorization: cred,
      },
    });
  }

  updateUser(user, cred) {
    const data = {
      email: user.email,
      name: user.name,
      firstname: user.firstname,
      lastname: user.lastname,
      password: user.autho,
      username: user.email,
      id: user.id,
      autho: user.autho,
    };
    return api.put("/user", data, cred);
  }

  updateShowInfo(user, cred) {
    return api.put("/user/teste", user, cred);
  }

  deleteUser(email, cred) {
    return api.delete(`/user/${email}`, cred);
  }

  sendEmail(dados, cred) {
    return api.post("/error/sendError", dados, cred);
  }

  reports(cred) {
    return api.get("/reports", cred);
  }

  limitedReports(cred, lastUsers) {
    return api.get(`/last/reports/${lastUsers}`, cred);
  }

  forgotPass(email) {
    const data = { mail: email };
    return api.post("/auth/forgotPass", data);
  }

  changePass(email, lastPassword, newPassword, cred) {
    const form = new FormData();
    form.append("oldPassword", lastPassword);
    form.append("newPassword", newPassword);

    return api.post(`/user/changePass/${email}`, form, cred);
  }

  postLastAccess(email, date, cred) {
    const form = new FormData();
    form.append("lastAccess", date);
    return api.post(`/user/lastAccess/${email}`, form, cred);
  }

  // SYSTEM
  isAlive(cred) {
    return api.get("/isAlive", cred);
  }

  changeStatusSystem(cred) {
    return api.get("/changeStatusSystem", cred);
  }

  //exercises
  listExercisesUser(type, cred) {
    return api.get(`/exercise/user/list?type=${type}`, cred);
  }

  listExercisesAdmin(type, cred) {
    return api.get(`/exercise/admin/list?type=${type}`, cred);
  }

  saveExercise(data, cred) {
    return api.post("/exercise", data, cred);
  }

  updateExercise(id, data, cred) {
    return api.put(`/exercise/${id}`, data, cred);
  }

  validateExercise(id, input, config) {
    return api.post(`/exercise/validate/${id}`, input, config);
  }

  deleteExercise(exerciseId, cred) {
    return api.delete(`/exercise/${exerciseId}`, cred);
  }

  version() {
    return api.get("/version");
  }
}

export default new DataService();
